export default __webpack_public_path__ + "static/media/txt.4186cab5.svg";